import { LOCALE_STATUS } from '../../constants';
export var getLocales = function (state) { var _a; return (_a = state.locales) !== null && _a !== void 0 ? _a : []; };
export var getLocaleByLanguage = function (state, language) {
    return getLocales(state).find(function (locale) { return locale.id === language; });
};
export var getDefaultSiteLocale = function (state) {
    return getLocales(state).find(function (locale) { return locale.status === LOCALE_STATUS.DEFAULT; });
};
